module.exports = __webpack_public_path__ + "img/logo-text.385c761f.png";